<script lang="ts">
	import { Button } from "#lib/web-ui/ui/button/index.js";
	import CameraIcon from "@lucide/svelte/icons/camera";
	import DollarSignIcon from "@lucide/svelte/icons/dollar-sign";
	import XIcon from "@lucide/svelte/icons/x";
	import ArrowRightIcon from "@lucide/svelte/icons/arrow-right";
	import { getTemplateContext } from "#lib/web-ui/home-buyers-template/template-context.svelte.js";

	let visibleFloating = $state(true);
	let visibleDesktop = $state(true);

	const templateContext = getTemplateContext();

	const title = "Want to Earn Extra Cash?";
	const subTitle = `Get paid for taking photos of distressed properties in the ${templateContext.serviceArea} area`;
	const ctaText = "Start Earning Today";
	const ctaUrl = "/get-paid";
</script>

<!-- Desktop banner - only visible on md screens and up -->
{#if visibleDesktop}
	<div class="relative z-10 mx-auto -mb-16 hidden max-w-5xl md:block">
		<div class="-mt-12"></div>
		<div class="border-primary overflow-hidden rounded border-2 shadow-lg">
			<div class="from-primary/80 to-primary relative bg-linear-to-r px-10 py-8">
				<button
					onclick={() => (visibleDesktop = false)}
					class="hover:text-primary absolute top-3 right-3 rounded text-white hover:bg-white"
					aria-label="Close"
				>
					<XIcon class="h-4 w-4" />
				</button>

				<div class="flex items-center justify-between gap-6">
					<div class="flex items-center gap-4">
						<div class="shrink-0 rounded-full bg-white p-3">
							<CameraIcon class="text-primary h-6 w-6" />
						</div>
						<div class="text-left">
							<h3 class="text-xl font-bold text-white">{title}</h3>
							<p class="mt-1 text-cyan-100">
								{subTitle}
							</p>
						</div>
					</div>
					<Button
						href={ctaUrl}
						variant="secondary"
						class="text-primary/80  hover:bg-primary min-w-52 rounded border bg-white hover:text-white"
					>
						{ctaText}
						<ArrowRightIcon
							class="ml-2 h-4 w-4 transition-transform group-hover:translate-x-1"
						/>
					</Button>
				</div>
			</div>
		</div>
	</div>
{/if}

<!-- Mobile floating banner - only visible on smaller screens -->
{#if visibleFloating}
	<div class="fixed bottom-0 left-0 z-50 mb-4 w-full max-w-screen justify-center md:hidden">
		<div
			class="from-primary/80 to-primary border-primary relative mx-4 overflow-hidden rounded border-2 bg-linear-to-r px-4 py-3 shadow-xl"
		>
			<button
				onclick={() => (visibleFloating = false)}
				class="hover:text-primary absolute top-2 right-2 rounded text-white hover:bg-white"
				aria-label="Close"
			>
				<XIcon class="h-4 w-4" />
			</button>

			<div class="flex items-center justify-between">
				<div class="flex items-center gap-3">
					<div class="shrink-0 rounded-full bg-white p-2">
						<DollarSignIcon class="text-primary h-4 w-4" />
					</div>
					<div>
						<span class="text-sm font-medium text-white">Earn Extra Cash?</span>
						<span class="ml-2 hidden text-xs text-cyan-100 sm:inline">
							Get paid for photos
						</span>
					</div>
				</div>
				<Button
					href={ctaUrl}
					variant="secondary"
					size="sm"
					class="text-primary/80  hover:bg-primary mr-4 h-8 rounded border bg-white hover:text-white"
				>
					Start Now
					<ArrowRightIcon class="ml-1 h-3 w-3" />
				</Button>
			</div>
		</div>
	</div>
{/if}
